// ABOUTME: Setting row with a title/subtitle on the left and a button on the right.
// ABOUTME: Same layout as StringSetting but with an onClick handler instead of an input.

import React from 'react';
import { Box, useTheme } from '@mui/material';
import Text from '../../theme/text/Text';
import Shbutton from '../../theme/buttons/Shbutton';
import { useTranslation } from "react-i18next";
import { tokens } from '../../../theme';
import EMGeneralExplainerBox from '../ModalsPopover/explainers/EMGeneralExplainerBox';

const ButtonSetting = (props) => {
  const { title = true, subtitle = true, variant = 1 } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      sx={{
        width: 1,
      }}
    >
      {/* Mobile */}
      <Box
        sx={{
          display:"none",
          "@media screen and (max-width: 47.9375em)": {
            display:"block"
          },
        }}
      >
        <Box
          sx={{
            ml:"-12px",
            mr:"-12px",
            pl:2,
            pr:1,
            display:"flex",
            py:1,
            borderRadius:7,
            gap:2,
            alignItems:"center",
            background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
            border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
            boxShadow:theme.palette.mode === "dark" ? null :  `0px 2px 4px ${colors.grey[200]}`,
          }}
        >
          <Text
            sx={props.explainer ? {display: "flex", alignItems: "center"} : {}}
            noBreak
            semibold
          >
              {t(props.title)}
              {props.explainer && <EMGeneralExplainerBox title={props.explainerTitle} text={props.explainerText}/>}
          </Text>

          <Box
            sx={{
              flex: 1,
              maxWidth: props.maxWidth ?? 300,
              marginLeft: "auto",
            }}
          >
            <Shbutton
              block
              size="32"
              color={props.color ?? (theme.palette.mode === "dark" ? "blue" : "primary")}
              variant="contained"
              onClick={props.onClick}
              endIcon={props.endIcon}
              startIcon={props.startIcon}
            >
              {props.btnText ?? t(props.title)}
            </Shbutton>
          </Box>
        </Box>
        {subtitle && variant !== 2 &&
          <Text
            light
            sx={{
              pt:1,
            }}
          >
            {t(props.subtitle)}
          </Text>
        }
      </Box>

      {/* Desktop */}
      <Box
        sx={{
          width: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 4,
          "@media screen and (max-width: 47.9375em)": {
            display:"none"
          },
        }}
      >
        <Box
          sx={{
            display:"flex",
            flexDirection:"column",
          }}
        >
          {title && <Text size={variant === 2 ?? "fs13"} semibold={variant !== 2}>{t(props.title)}</Text>}
          {subtitle && variant !== 2 && <Text light>{t(props.subtitle)}</Text>}
        </Box>

        <Box
          sx={{
            flex: 1,
            maxWidth: props.maxWidth ?? 300,
            marginLeft: "auto",
          }}
        >
          <Shbutton
            block
            size="32"
            color={props.color ?? (theme.palette.mode === "dark" ? "blue" : "primary")}
            variant="contained"
            onClick={props.onClick}
            endIcon={props.endIcon}
            startIcon={props.startIcon}
          >
            {props.btnText ?? t(props.title)}
          </Shbutton>
        </Box>
      </Box>
    </Box>
  );
};

export default ButtonSetting;
